import React from 'react';

import './style.css';
import './mobileStyles.css';
import { isMobile } from '../../helpers/utils';

const Validation = props => {
    const { message, className,messageId } = props;

    return (
        <div className={ isMobile() ? 'validation-block validation-block-mobile' : `${className} validation-block` }>
            <img
                alt="Not verified"
                className="iconImg" 
                src="/images/NotVerified-Icon.png"
            />
            <div id={messageId} className="icon-support-text italic">{ message }</div>
        </div>
    )
}

export default Validation;
